import React from 'react';
import { Helmet } from 'react-helmet-async';
import ErpSoftware from '../components/ErpSoftware';

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: 'Home', item: 'https://wayug.com/' },
    { '@type': 'ListItem', position: 2, name: 'ERP Software', item: 'https://wayug.com/erp-software' },
  ],
};

const softwareSchema = {
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: 'Wayug Custom Manufacturing & Steel ERP',
  operatingSystem: 'Web, Windows, Android, iOS',
  applicationCategory: 'BusinessApplication',
  offers: {
    '@type': 'Offer',
    price: '150000',
    priceCurrency: 'INR',
  },
  description: 'Custom ERP software for manufacturing, steel plants, rolling mills and industrial units in Delhi NCR, Ghaziabad & Noida. Weighbridge, inventory, GST e-way bill & Tally integration.',
  author: {
    '@type': 'Organization',
    name: 'Wayug Infotech Solutions',
    url: 'https://wayug.com',
  },
};

export default function ErpSoftwarePage() {
  return (
    <div className="page-content subpage-content">
      <Helmet>
        <title>ERP Software for Manufacturing &amp; Steel Industry | Delhi NCR – Wayug</title>
        <meta
          name="description"
          content="Custom ERP software for steel plants, rolling mills &amp; manufacturers in Ghaziabad, Noida &amp; Delhi NCR. Weighbridge integration, Tally sync, GST e-way bills &amp; stock control."
        />
        <link rel="canonical" href="https://wayug.com/erp-software" />
        <meta property="og:title" content="ERP Software for Manufacturing &amp; Steel Industry | Wayug Infotech" />
        <meta
          property="og:description"
          content="Automate steel mills and industrial manufacturing units with custom cloud ERP. Production tracking, scrap logs, GST e-invoicing &amp; real-time cost-per-tonne analysis."
        />
        <meta property="og:url" content="https://wayug.com/erp-software" />
        <meta property="og:type" content="website" />
        <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
        <script type="application/ld+json">{JSON.stringify(softwareSchema)}</script>
      </Helmet>
      <ErpSoftware />
    </div>
  );
}
